
import { useState, useEffect } from "react";
import LayoutPage from "../../Components/LayoutPage";
import CardContainer from "./Components/CardContainer";
import ChooseAccount from "./Components/ChooseAccount";
import TopMessage from "./Components/TopMessage";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../../config/api";

export default function Dashboard() {
  const [variant, setVarient] = useState("default");
  const [reason, setReason] = useState(null);
  const [description, setDescription] = useState(null);
  const navigate = useNavigate();
  const fetchActionData = async () => {
    try {
      let response = await fetch(
        `${API_BASE_URL}dashboard/next-action/`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access")}`,
          },
        },
      );

      // If access token is invalid/expired → try refresh
      if (response.status === 401) {
        const refreshResponse = await fetch(
          `${API_BASE_URL}auth/trader/jwt/refresh/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              refresh: localStorage.getItem("refresh"),
            }),
          },
        );

        if (!refreshResponse.ok) {
          // refresh failed → logout
          localStorage.removeItem("access");
          localStorage.removeItem("authCredentials");
          localStorage.removeItem("refresh");
          localStorage.removeItem("role");
          localStorage.removeItem("email");
          navigate("/signin");
          return; // ⬅️ IMPORTANT
        }

        const refreshData = await refreshResponse.json();
        localStorage.setItem("access", refreshData.access);

        // retry original request with new access token
        response = await fetch(
          `${API_BASE_URL}dashboard/next-action/`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access")}`,
            },
          },
        );
      }

      // Now handle final response (either first or retried)
      if (!response.ok) {
        throw new Error(`https error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Account Data:", data);
      setVarient(data.type);
      setReason(data?.reason || null);
      setDescription(data?.description || null);
    } catch (error) {
      console.error("Error fetching account data:", error);
    }
  };
  useEffect(() => {
    fetchActionData();
  }, []);

  return (
    <LayoutPage
      activeIndex={1}
      navItems={["میز کار"]}
      childrenClassName="w-full flex flex-col gap-5 overflow-y-auto overflow-x-hidden"
    >
      <TopMessage variant={variant} reason={reason} description={description} />
      <CardContainer />
      <div className="w-full min-h-[450px] h-fit flex flex-col items-center gap-5">
        <ChooseAccount />
      </div>
    </LayoutPage>
  );
}
